import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  ScannerQRCodeConfig,
  ScannerQRCodeResult,
  NgxScannerQrcodeService,
  NgxScannerQrcodeComponent,
  ScannerQRCodeSelectedFiles,
} from 'ngx-scanner-qrcode';
import { ApplicationService } from 'src/app/core/services/application.services';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';

@Component({
  selector: 'app-evaluator-scan-qr',
  templateUrl: './evaluator-scan-qr.component.html',
  styleUrls: ['./evaluator-scan-qr.component.scss']
})
export class EvaluatorScanQrComponent implements OnInit {
  private hasCalledAPI: boolean = false;

  @ViewChild('action') action!: NgxScannerQrcodeComponent;

  public config: ScannerQRCodeConfig = {
    constraints: {
      video: {
        width: window.innerWidth
      },
    },
  };
  constructor(private qrcode: NgxScannerQrcodeService, private applicationService: ApplicationService,
    private router: Router, private notif: ToastNotificationService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.action.isReady.subscribe((res: any) => {
      // this.handle(this.action, 'start');
    });
  }

  public onEvent(e: ScannerQRCodeResult[], action?: any): void {
    const qrData = e[0].value;
    if (qrData && !this.hasCalledAPI) {
      this.hasCalledAPI = true;
      this.applicationService.getApplicationDetails(qrData).subscribe(res => {
        if (res) {
          this.action.stop();
          this.notif.openSnackBar("Scan Successful!")
          setTimeout(() => {
            this.router.navigate(['/evaluator/dashboard/scheduling/result', res.data.id]);
          }, 2000);
        }
      });
    }
  }

  public handle(action: any, fn: string): void {
    const playDeviceFacingBack = (devices: any[]) => {
      // front camera or back camera check here!
      const device = devices.find(f => (/back|rear|environment/gi.test(f.label))); // Default Back Facing Camera
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    }

    if (fn === 'start') {
      action[fn](playDeviceFacingBack).subscribe((r: any) => {}, alert);
    } else {
      action[fn]().subscribe((r: any) => {}, alert);
    }
  }


}
